<template>
  <div>
    <div>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <!--Created At Filter --->
          <div class="col-12 col-md-6">
            <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
            <RangeDatePicker
              id="date-filter-picker"
              v-model="filters.date"
              class="col-12 datesFilter"
              :placeholder="$t('optometry.leads.date_range')"/>
          </div>

          <!----->
        </div>
      </div>
      <v-server-table
        id="iframeMediaTable"
        ref="iframeMediaTable"
        name="iframeMediaTable"
        :columns="columns"
        :options="tableOptions"
        @filter="onFilterUpdate"
        @loading="isLoading = true"
        @loaded="onLoaded"
        @row-click="handleMediaClicked"
        @pagination="onPagination">

        <span slot="beforeFilter">
          <span>
            <va-popover
              v-if="selectedMediaIds.length > 0"
              placement="left"
              :message="$t('iframe.actions.delete')">
              <span class="icon fa fa-trash-o clickable" @click.prevent="onClickDelete()"></span>
            </va-popover>
          </span>
          <!--<span>
            <va-popover
              v-if="selectedMediaIds.length > 0"
              placement="left"
              :message="$t('iframe.actions.lock')">
              <span class="icon fa fa-lock clickable" @click.prevent="onClickLock()"></span>
            </va-popover>
          </span>-->
        </span>
        <span slot="h__selectMedia">
          <span class="round">
            <input class="selectMediaCheckbox" type="checkbox" id="checkboxSelectAllMedias" :checked="selectAllMedias" @click="selectAllMedias = !selectAllMedias">
            <label class="selectMediaCheckbox" for="checkboxSelectAllMedias"></label>
          </span>
        </span>
        <span slot="selectMedia" slot-scope="props" >
        <span class="round">
            <input class="selectMediaCheckbox" type="checkbox" :id="`checkbox${props.row.id}`" :checked="selectedMedias[props.row.id]" @click="handleMediaSelected(props.row)">
            <label class="selectMediaCheckbox" :for="`checkbox${props.row.id}`"></label>
          </span>
      </span>
        <span slot="created_at" slot-scope="props">
          {{props.row.created_at | localTime('YYYY-MM-DD HH:mm')}}
        </span>

        <span slot="client" slot-scope="props">
          {{props.row.client_id ? clientOptions.find(elem => elem.id === props.row.client_id).name : "N/A"}}
        </span>

        <span slot="actions" slot-scope="props" class="w-100 d-flex justify-content-center">
          <va-popover :message="$t('iframe.actions.delete')" placement="top">
            <i class="report-action-icon fa fa-trash-o p-2 clickable" @click.prevent.stop="onClickDelete(props.row)"></i>
          </va-popover>
         <!-- <va-popover :message="$t('iframe.actions.lock')" placement="top">
            <i class="report-action-icon fa fa-lock p-2 clickable"
               @click.prevent.stop="onClickLock(props.row)"></i>
          </va-popover>-->
        </span>

        <!-- <span slot="lang" slot-scope="props">
          {{props.row.lang.toUpperCase() || "N/A"}}
        </span>

        <span slot="country" slot-scope="props">
          {{props.row.country.toUpperCase() || "N/A"}}
        </span> -->


      </v-server-table>
    </div>
    <ConfirmationModal v-if="showDeleteConfirmationModal"
                      :title="confirmationModalTitle"
                      :body="confirmationModalBody"
                      okClass="btn-danger"
                      @modal-confirmed="confirmDelete"
                      @modal-canceled="cancelDelete"
    >
    </ConfirmationModal>
    <ConfirmationModal v-if="showLockConfirmationModal"
                       :title="lockConfirmationModalTitle"
                       :body="lockConfirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="confirmLock"
                       @modal-canceled="cancelLock"/>
  </div>
</template>

<script>

import RangeDatePicker from "@/components/common/RangeDatePicker";
import TableQueryMixin from "@/mixins/TableQueryMixin";
import ApiService from "@/api/ApiService";
import axios from "axios";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {IframeService} from "@/api/IframeService";
// import IframeBlocksTableMixinVue from '@/mixins/IframeBlocksTableMixin.vue';

export default {
  components: {ConfirmationModal, LoadingPlaceholder, RangeDatePicker},
  mixins: [
    TableQueryMixin,
    // IframeBlocksTableMixinVue
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
        date: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD'),
        }
      },
      selectedMedia: null,
      // showCreateBlock: false,
      selectedMedias: {},
      selectedMediaIds: [],
      selectAllMedias: false,
      isLoading: false,
      pageResourceIdentifier: 'noise-items',
      queryUrl: `${this.$store.state.iframe_server}v1/noise-items`,
      // queryUrl: 'https://621e4716849220b1fc95200d.mockapi.io/flows',
      columns: ['selectMedia', 'created_at', 'name', 'client', 'lang', 'actions'],
      tableOptions: {
        orderBy:{
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at'],
        sortable: ['created_at'],
        customFilters: ['start', 'end'],
        columnsClasses: {
          selectBlock: 'selectBlockClass',
          created_at: 'createdAtClass',
          lang: 'text-center',
          actions: 'w-100 d-flex justify-content-center'
        },
        headings: {
          created_at: this.$t('iframe.table_headings.created_at'),
          name: this.$t('iframe.table_headings.name'),
          lang: this.$t('iframe.table_headings.lang'),
          actions: this.$t('iframe.table_headings.actions'),
          client: this.$t('iframe.table_headings.client')
        }
      },
      showDeleteConfirmationModal: false,
      selectedMediaToDelete: null,
      showLockConfirmationModal: false,
      selectedMediaForLock: null,
    }
  },
  mounted() {
    let dropdownList = this.$el.getElementsByClassName('VueTables__columns-dropdown')[0].lastElementChild
    dropdownList.removeChild(dropdownList.childNodes[0])
  },
  methods: {
    onLoaded: function() {
      this.selectAllMedias = false
      this.selectedMedias = {}
      const medias = this.getData()
      for (const media of medias) {
        this.selectedMedias[media.id] = false
      }
      this.isLoading = false
    },
    onPagination: function() {
      this.selectAllMedias = false
      this.selectedMedias = {}
    },
    onClickLock: function (media = null) {
      if (media) {
        this.selectedMediaForLock = media
      }
      this.showLockConfirmationModal = true
    },
    onClickDelete: function(media = null) {
      if(media) {
        this.selectedMediaToDelete = media
      }
      this.showDeleteConfirmationModal=true
    },
    getData: function() {
      return this.$refs.iframeMediaTable.data
    },
    reload: function () {
      this.$refs.iframeMediaTable.refresh()
    },
    confirmDelete: function(media = null) {
        const multiple = this.selectedMediaToDelete === null
        let ids = multiple
          ? this.getSelectedMediasIds()
          : parseInt(this.selectedMediaToDelete.id)

        IframeService.deleteMedia(ids).then(res => {
          setTimeout(() => {
            if(multiple) {
              this.showToast(this.$t('iframe.media_library.multiple_deleted', {nr: ids.length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.media_library.deleted'), this.$store.state.successToastOptions)
            }
            this.reload()
          }, 500)
        }).catch(err => {
          setTimeout(() => {
            let keys = Object.keys(err.response.data.errors)
            for (let key of keys) {
              let errorMessages = err.response.data.errors[key].map(errors => errors)
              if (errorMessages.some(msg => msg.replaceAll(' ','_').toLowerCase() === 'cannot_delete_noise_item(s)_that_are_assigned_to_hearing_test(s)')) {
                this.showToast(this.$t('iframe.media_library.error_item_used'), this.$store.state.errorToastOptions)
              } else {
                this.showToast(this.$t('iframe.media_library.delete_error'), this.$store.state.errorToastOptions)
              }
            }
          })
        }).finally(() => {
          this.resetAfterAction()
        })

    },
    cancelDelete: function () {
      this.showDeleteConfirmationModal = false
      this.selectedMediaToDelete = null
    },
    confirmLock: function() {
      const multiple = this.selectedMediaForLock === null
      let ids
      if(multiple) {
        ids = this.getSelectedMediasIds()
      } else {
        ids = parseInt(this.selectedMediaForLock.id)
      }

      IframeService.lockMedia(true, ids).then(res => {
        setTimeout(() => {
          if(multiple) {
            this.showToast(this.$t('iframe.blocks_builder.multiple_locked', {nr: ids.length}), this.$store.state.successToastOptions)
          } else {
            this.showToast(this.$t('iframe.blocks_builder.deleted'), this.$store.state.successToastOptions)
          }
          this.reload()
        }, 500)
      }).catch(err => {
        setTimeout(() => {
          let keys = Object.keys(err.response.data.errors)
          for (let key of keys) {
            let errorMessages = err.response.data.errors[key].map(errors => errors)
            this.showToast(this.$t('iframe.blocks_builder.delete_error'), this.$store.state.errorToastOptions)
          }

        })
      }).finally(() => {
        this.resetAfterAction()
      })
    },
    cancelLock: function () {
      this.showLockConfirmationModal = false
      this.selectedMediaForLock = null
    },
    resetAfterAction: function () {
      this.showDeleteConfirmationModal = false
      this.showLockConfirmationModal = false
      this.selectAllMedias = false
      this.selectedMedias = {}
      const medias = this.getData()
      for (const media of medias) {
        this.selectedMedias[media.id] = false
      }
      this.selectedMediaToDelete = null
      this.selectedMediaForLock = null
      this.selectedMediaIds = this.getSelectedMediasIds()
    },
    handleMediaClicked: function({event, row}) {
      if(event.srcElement.className ==="selectMediaCheckbox") {
        event.stopPropagation()
      } else {
        let selectedMedia = row
        // const entity = this.entities.filter(entity => entity.id === row.client_id)[0]
        // selectedMedia.client = entity ? entity : null
        this.$emit('mediaClicked', selectedMedia)
        // this.$router.push(`/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder/${this.blockTypeIdentifier}/${row.id}`)
      }
    },
    handleMediaSelected: function (media) {
      this.selectedMedias[media.id] = !this.selectedMedias[media.id]
      this.selectedMediaIds = this.getSelectedMediasIds()
    },
    getSelectedMediasIds: function () {
      const keys = Object.keys(this.selectedMedias)
      let selectedMediasIds = keys.filter(key => this.selectedMedias[key] === true)
      for(let elem of selectedMediasIds) {
        elem = parseInt(elem)
      }
      return selectedMediasIds
    },
  },
  watch: {
    customQueries: {
      handler: function (value) {
        if (value) {
          if (value.start && value.start !== '') {
            this.filters.date.start = value.start
          }
          if (value.end && value.end !== '') {
            this.filters.date.end = value.end
          }
        }
      },
      immediate: true
    },
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs.iframeMediaTable.setFilter(value)
    },
    'filters.date': function (value) {
      this.$refs.iframeMediaTable.customQueries.start = value.start || ''
      this.emitTableFilter('vue-tables.iframeMediaTable.filter::end', value.end || '')
    },
    selectAllMedias: function(value) {
      const keys = Object.keys(this.selectedMedias)
      for (const key of keys) {
        this.selectedMedias[key] = value
      }
      this.selectedMediaIds = this.getSelectedMediasIds()
    },
  },
  computed: {
    confirmationModalTitle: function(){
      return this.selectedMediaToDelete !== null ? this.$t('iframe.media_library.delete_item_title') : this.$t('iframe.media_library.delete_multiple_items_title')
    },
    confirmationModalBody(){
      return this.selectedMediaToDelete !== null
        ? this.$t('iframe.media_library.delete_item_body', {name: this.selectedMediaToDelete.name})
        : this.$t('iframe.media_library.delete_multiple_items_body', {nr: this.getSelectedMediasIds().length})
    },
    lockConfirmationModalTitle: function () {
      return this.selectedMediaForLock !== null ? this.$t('iframe.titles.lock_project') : this.$t('iframe.titles.lock_multiple_projects')
    },
    lockConfirmationModalBody: function () {
      return this.selectedMediaForLock !== null
        ? this.$t('iframe.titles.lock_project_modal_body', {name: this.selectedMediaForLock.name})
        : this.$t('iframe.titles.lock_multiple_projects_modal_body', {nr: this.getSelectedMediasIds()})
    },
    entities: function () {
      if (this.iframeService) {
        return this.iframeService.entities
      }
      return null
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style>
#iframeMediaTable .VueTables__search {
  justify-content: space-between;
  float:none !important;
}
.table-hover tbody tr:hover{
  background: rgba(41, 196, 170, 0.5) !important;
}
.selectBlockClass{
  width: 50px;
}
.createdAtClass {
  width: 300px;
}
</style>
<style scoped>

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

</style>
